function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  fill: "transparent",
  width: 283.465,
  height: 283.465
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M109.798,104.994c-5.96,0-11.131,3.365-13.729,8.296l-18.685,33.718c-0.348,0.629-0.984,0.672-1.415,0.097 L53.051,117.29c-0.438-0.569-1.383-1.035-2.102-1.035H10.558c-0.718,0-1.076,0.542-0.796,1.202l0.009,0.004 c0.292,0.9,2.846,8.236,12.613,11.568c10.644,3.634,15.67,0.467,19.215,2.504c0.441,0.342,0.868,0.758,1.114,1.13l37.865,57.061 c0.43,0.575,1.066,0.532,1.414-0.097l24.392-43.388l0.034,108.993h35.299V111.3h-18.966 C119.254,107.706,114.915,104.994,109.798,104.994z M272.908,116.255h-40.392c-0.718,0-1.665,0.466-2.101,1.035l-22.92,29.814 c-0.431,0.575-1.066,0.532-1.414-0.097l-18.686-33.718c-2.597-4.931-7.768-8.296-13.729-8.296c-5.117,0-9.455,2.712-12.952,6.307 h-18.967v143.932h35.3l0.033-108.993l24.393,43.388c0.348,0.629,0.983,0.672,1.414,0.097l37.864-57.061 c0.247-0.372,0.673-0.788,1.114-1.13c3.545-2.037,8.57,1.13,19.217-2.504c9.766-3.332,12.32-10.668,12.611-11.568l0.01-0.004 C273.984,116.797,273.626,116.255,272.908,116.255z"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  fill: "#FFFFFF",
  cx: 141.718,
  cy: 91.366,
  r: 26.387
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "border",
  d: "M114.179,91.366c0,15.184,12.354,27.538,27.538,27.538c15.185,0,27.539-12.354,27.539-27.538 c0-15.186-12.354-27.54-27.539-27.54C126.534,63.826,114.179,76.18,114.179,91.366z M116.483,91.366 c0-13.915,11.32-25.235,25.234-25.235c13.916,0,25.236,11.32,25.236,25.235c0,13.914-11.32,25.234-25.236,25.234 C127.803,116.6,116.483,105.279,116.483,91.366z"
});

function SvgVetInte(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 284,
    height: 284,
    viewBox: "0 0 284 284",
    enableBackground: "new 0 0 284 284",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVetInte);
export default __webpack_public_path__ + "static/media/vet_inte.c2266b80.svg";
export { ForwardRef as ReactComponent };